import { render, staticRenderFns } from "./features.vue?vue&type=template&id=601b5f90&scoped=true&"
import script from "./features.vue?vue&type=script&lang=js&"
export * from "./features.vue?vue&type=script&lang=js&"
import style0 from "./features.vue?vue&type=style&index=0&id=601b5f90&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601b5f90",
  null
  
)

/* custom blocks */
import block0 from "./features.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports